//////////////////////
// [Most updated version]
// Function to iterate through all elements with tool- type class
// Then updates that element with correct url and appropriate attribution tag
// Attribution tag can be submitted via url or directly in a link
//////////////////////
function all_tool_urls(){
  var tool_urls = {};
  tool_urls["tool-5610"] = "https://www.amazon.com/5610-OBD2-Scanner-Bidirectional/dp/B07Z481NJM/?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5512"] = "https://www.amazon.com/5512-OBD2-Scanner-abs-bleed-obd1/dp/B09WPW4WQ4?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5510"] = "https://www.amazon.com/5510-OBD2-Scanner-abs-bleed/dp/B07Z48NKF1?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5410"] = "https://www.amazon.com/5410-OBD2-Scanner-all-system-scaner/dp/B07ZL7CLYR?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5310"] = "https://www.amazon.com/5310-OBD2-Scanner-abs-srs/dp/B07ZL746BR?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5210"] = "https://www.amazon.com/5210-OBD2-Scanner-abs/dp/B07Z46L5FG?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5110"] = "https://www.amazon.com/5110-OBD2-Scanner-code-reader/dp/B07Z46KNLR?m=A338X9NNA1JLZE&maas=";

  tool_urls["tool-3360"] = "https://www.amazon.com/INNOVA-3360-Infrared-Thermal-Camera/dp/B09WRQ3LFH?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-3380"] = "https://www.amazon.com/Innova-3380-Boroscope/dp/B082JCSB4Z?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-ds200"] = "https://www.amazon.com/INNOVA-DS200-High-Speed-Multimeter/dp/B0BYBLFFGM?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-5420"] = "https://www.amazon.come/Innova-Power-Check-Electrical-Tester/dp/B09ZQ3ZQV2?m=A338X9NNA1JLZE&maas=";
  tool_urls["tool-1000"] = "https://www.amazon.com/Innova-1000-OBD2-Scanner-Bluetooth/dp/B0D32BNNQ9?m=A338X9NNA1JLZE&maas=";

  tool_urls["tool-5160rs"] = "https://www.amazon.com/5160RS-Bidirectional-OE-Level-Diagnostics-Recommended/dp/B071VYLP32?maas=";
  tool_urls["tool-3160rs"] = "https://www.amazon.com/INNOVA-3160RS-Scanner-Service-Network/dp/B084SVSFZY?maas=";
  tool_urls["tool-3130rs"] = "/products/fixassist-3130rs?tag=";
  tool_urls["tool-3100rs"] = "https://www.amazon.com/Innova-3100RS-Scanner-Reader-Service/dp/B084SW4K8J?maas=";
  tool_urls["tool-3040rs"] = "https://www.amazon.com/INNOVA-3040RS-Scanner-Battery-Testing/dp/B084SVS383?maas=";
  tool_urls["tool-3020rs"] = "https://www.amazon.com/Innova-3020RS-Scanner-Reader-Emissions/dp/B084SWJL4J?maas=";
  tool_urls["tool-3215rs"] = "/products/fixassist-3215rs?tag=";

  tool_urls["tool-7100p"] = "/products/obd2-scantool-with-abs-srs-7100p?tag=";
  tool_urls["tool-6200p"] = "/products/innova-6200p-obd2-scan-tool?tag=";
  tool_urls["tool-6100p"] = "/products/obd2-w-abs-srs-diagnostic-tool-6100p?tag=";
  tool_urls["tool-6030p"] = "/products/obd2-6030p-scan-tool-6030p?tag=";
  tool_urls["tool-7111"] = "/products/smart-diagnostic-system-obd2-tablet-7111?tag=";
  
  tool_urls["shop"] = tool_urls["tool-5610"];
  return tool_urls;
}

function page_default_attributions(){
  var default_attr = {};

  // They are all in : https://advertising.amazon.com/attribution/campaigns/576880478548469873/attribution-tags?entityId=ENTITY2AQVTE4950NDM
  default_attr["home"] = "maas_adg_D1CC6AD084F39E48130956356E99824F_afap_abs";
  default_attr["comparison"] = "maas_adg_861336826BA2BBB7929769E97CFC7A95_afap_abs";
  default_attr["blog"]      = "maas_adg_700D77964CB95BCF8CFC220A6BEB1BB7_afap_abs";  
  default_attr["topcta"]    = "maas_adg_224C813FCB8DC8526F33BFFC50DFD2CD_afap_abs";  
  default_attr["cta_quiz_regular"] = "maas_adg_3C93CAD946D06914E7924F852084AA3D_afap_abs"; 
  default_attr["cta_shop_regular"] = "maas_adg_224C813FCB8DC8526F33BFFC50DFD2CD_afap_abs"; 
  default_attr["google_shopping"] = "maas_adg_8F563EABB62E48C1C643B7AB96FE144E_afap_abs";
  default_attr["shop"] = "maas_adg_4F5678E73EF03C0649ADCD65DA17ABB0_afap_abs"; // shop default
  default_attr["coverage_checker"] = "maas_adg_B77500C1A6D08819730EA20AC80E92FF_afap_abs";
  default_attr["tool-5610"] = "maas_adg_A981334ED1F754B2D2E960E33D8213A2_afap_abs";  
  default_attr["tool-5512"] = "maas_adg_A86956E47E3DFDB1EE447339C7A6E209_afap_abs";
  default_attr["tool-5510"] = "maas_adg_655916D78319D942471249987C2F22AD_afap_abs";
  default_attr["tool-5410"] = "maas_adg_34AC3B141E88E3F2B7A9CDA42EA31703_afap_abs";
  default_attr["tool-5310"] = "maas_adg_D85713BC918A039AB7B1C57C96667CAA_afap_abs";
  default_attr["tool-5210"] = "maas_adg_A0F9FB85C53023CCEBAD8982567475CC_afap_abs";
  default_attr["tool-5110"] = "maas_adg_E1170F0F141D2711F9101E18A163E731_afap_abs";
  default_attr["tool-1000"] = "maas_adg_05E0647EBC0B49B746851E1CAC429C25_afap_abs";

  default_attr["tool-5160rs"] = "maas_adg_8A0B5ABEFDE1533EFDB6B6B280E9DA93_afap_abs";
  default_attr["tool-3170rs"] = "maas_adg_79F5CD4A01AB870F28DDD89B542DA00E_afap_abs";
  default_attr["tool-3160rs"] = "maas_adg_1BCF723C1696706C6D954657208A843D_afap_abs";
  default_attr["tool-3130rs"] = "maas_adg_488D1056460B6A5FE330813A7A728D60_afap_abs";
  default_attr["tool-3100rs"] = "maas_adg_566026E09A8402576C43F893B8C64EE7_afap_abs";
  default_attr["tool-3040rs"] = "maas_adg_ABD09C3768C0A8890038B2B1FD3E9C3B_afap_abs";
  default_attr["tool-3020rs"] = "maas_adg_D3FD2F0EF6233F8471FF35A38248C58D_afap_abs";
  
  return default_attr;
}

function affil_tag(){
    //return 'innova08-20';
    return '';
}


//////////////////////
// [Private] Function to find and return all elements with a class containing 'tool-'
//////////////////////
function find_elements_with_tool_class() {
    // Get all elements with class name containing 'tool-'
    const elements = document.querySelectorAll('[class*="tool-"]');
    // Convert NodeList to an array
    return Array.from(elements);
}

//////////////////////
// [Private]
// Get Attribution in Tag Param
//////////////////////
function get_tag_param(){
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('tag');
}

//////////////////////
// [Public]
// Constructs rest of the attribution link content 
// Looks at page_name for default attribution, parameters, and local overrides for its final result
//   page_name = from the keys of page_default_attributions() above - it is for applying a default attribution if there is no tag or local override
//////////////////////
function get_attribution(page_name,local_override=null){
  var attr = get_tag_param();

  // If there is no tag, use local override
  if( local_override != null ){
    attr = local_override;
  }
  // If there is no tag and no local override, use default
  if( attr == null ){
    attr = page_default_attributions()[page_name];
  } 
  return attr;
}

function attribution_append(page_name,local_override=null){
  return get_attribution(page_name) + "&ref_=aa_maas&tag=" + affil_tag();
}



//////////////////////////////////////////////////////////////
// [Public]
// Change url of element without worrying about the specifics
//////////////////////////////////////////////////////////////
function update_element_url(element,final_url){
  // Look for Image elements
  if( element.nodeName == "IMG" ){
	element.setAttribute("data-href",final_url );
  }
  // Look for Text titles
  else if( element.nodeName == "H3" ){
	element.firstElementChild.href = final_url;
  }
  // Look for urls created from text using pagefly editor (they are <p><href></href></p>)
  else if( element.nodeName == "P" ){
	element.firstElementChild.href = final_url;
  }
  // These are basic ahrefs from Buttons and Comparison charts
  else{
	element.href = final_url;
  }  
}

//////////////////////
// [Public] tool-* attribution
// Iterate through all elements with class of "tool-*" (*=wildcard) -
//   updating that object with correct link + attr data
//////////////////////
function process_tool_elements(page_name, local_override=null) {
    const toolElements = find_elements_with_tool_class();
    const toolURLs = all_tool_urls();
    const attribution = attribution_append(page_name,local_override);

    // loop
    toolElements.forEach(element => {
        // Find the class that starts with 'tool-'
        const classes = element.className.split(' ');
        const toolclass = classes.find(className => className.startsWith('tool-'));

        if (toolclass) {
            const tool_url = toolURLs[toolclass];
            if(tool_url) {
              update_element_url(element,tool_url+attribution)
            }
        }
    });
}

//////////////////////
// [Public] Typeform attribution
// Iterate through all elements with [typeform] class
//   updating that object with correct link + attr data
//////////////////////
function process_typeform_elements(page_name, local_override=null) {
  const attribution = get_attribution(page_name,local_override);
  const tfElements = document.querySelectorAll('a.typeform');

  // for loop
  tfElements.forEach(link => {
      const linkUrl = new URL(link.href);
      
      // Update the 'tag' parameter value with the page's 'tag' value
      linkUrl.searchParams.set('tag', attribution);
      
      // Update the link href
      link.href = linkUrl.toString();
  });
}

////////////////////////////////////////////////////////////////////////////////
// Link identifier methods 
// Does not identify/process elements by classes or IDs but by link
////////////////////////////////////////////////////////////////////////////////

//////////////////////
// [Public] Typeform attribution
// Iterate through all elements with <a> going to typeform "finder" page
//   updating that object with attr data
//////////////////////
function process_typeformlinks_elements(page_name, local_override=null){
  // Get all <a> elements on the page
  const links = document.querySelectorAll('a');
  const attribution = get_attribution(page_name,local_override);

  // Iterate through each link
  links.forEach(link => {
    // Check if the link is an Amazon link
    if (link.href.includes('finder')) {
      // Remove existing parameters
      const url = new URL(link.href);
      url.search = '';  // Clear all existing parameters
      
      // Add new parameters
      url.search = "tag="+attribution;
      
      // Update the href of the link
      link.href = url.toString();
    }
  });  
}

//////////////////////
// [Public] Blog attribution
// Iterate through all elements with <a> going to amazon.com
//   updating that object with attr data
//////////////////////
function process_amazoncomlinks_elements(page_name, local_override=null) {
  // Get all <a> elements on the page
  const links = document.querySelectorAll('a');
  const attribution = attribution_append(page_name,local_override);
  console.log(attribution);

  // Iterate through each link
  links.forEach(link => {
    // Check if the link is an Amazon link
    if (link.href.includes('amazon.com')) {
      // Remove existing parameters
      const url = new URL(link.href);
      url.search = '';  // Clear all existing parameters
      
      // Add new parameters
      url.search = "maas="+attribution;
      
      // Update the href of the link
      link.href = url.toString();
    }
  });
}